export const personTypes = {
  PJ: "pj",
  PF: "pf"
};
